import { BankAccountTypeEnumKeys } from "./shapes/BankAccountTypeEnum"

const ListSourceBankAccountsItemSchema = {
  accountType: { enum: BankAccountTypeEnumKeys },
  isSourceVerified: { type: 'boolean' },
  isInvalid: { type: 'boolean' },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default ListSourceBankAccountsItemSchema
